<template>
  <div>
    <KTCodePreview v-bind:title="'Thông tin chương trình thưởng hoa hồng'">
      <template v-slot:preview>
        <b-form ref="form" lazy-validation class="row">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12">
                    <b-form-group class="required-control">
                      <label>Tên chương trình</label>
                      <b-form-input
                        size="sm"
                        v-model="$v.mainModel.name.$model"
                        placeholder="Nhập tên"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <label>Mô tả</label>
                      <b-form-textarea
                        v-model="mainModel.description"
                        placeholder="Nhập mô tả"
                        rows="5"
                        :max-length="255"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <b-col cols="6">
                    <b-form-group class="required-control">
                      <label>Từ ngày:</label>
                      <date-picker
                        placeholder="Từ ngày"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="mainModel.startAt"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <label>Đến ngày</label>
                      <date-picker
                        placeholder="Đến ngày"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="mainModel.endAt"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="6"
                    v-show="mainModel.mode === REWARD_PROGRAM_TYPE.HH_CR"
                  >
                    <b-form-group>
                      <label>Bộ phận</label>
                      <b-form-select
                        size="sm"
                        v-model="mainModel.departmentId"
                        :options="listDepartment"
                        value-field="id"
                        text-field="name"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >-- Tất cả bộ phận --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <label>Trạng thái</label>
                      <b-form-select
                        size="sm"
                        v-model="mainModel.status"
                        :options="listStatus"
                        value-field="id"
                        text-field="name"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="d-flex justify-content-between">
                    <span>
                      Hoá đơn không được tính thưởng:<b-badge
                        variant="primary"
                        style="cursor: pointer"
                        @click="showExcludeBillRewardListModal"
                        >{{ excludeBillRewardCount }}</b-badge
                      >
                    </span>
                    <b-button
                      type="button"
                      variant="secondary"
                      size="sm"
                      @click="showModalImportExcelExcludeBillReward"
                    >
                      <i style="font-size: 1rem" class="far fa-file-excel"></i
                      >Nhập từ excel
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-show="mainModel.mode === REWARD_PROGRAM_TYPE.HH_CH">
              <b-col cols="6">
                <b-form-group>
                  <label
                    >Cửa hàng áp dụng (để trống nếu áp dụng toàn hệ
                    thống)</label
                  >
                  <b-input-group>
                    <vue-multi-select
                      style="margin-bottom: 2rem"
                      v-model="mainModel.storeIds"
                      :options="stores"
                      placeholder="Chọn cửa hàng"
                      option-label="name"
                    ></vue-multi-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <label
                    >Cửa hàng áp dụng bán buôn (để trống nếu không áp dụng cho
                    cửa hàng nào)</label
                  >
                  <b-input-group>
                    <vue-multi-select
                      style="margin-bottom: 2rem"
                      v-model="mainModel.wholesaleStoreIds"
                      :options="wholesaleStores"
                      placeholder="Chọn cửa hàng"
                      option-label="name"
                    ></vue-multi-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <h4>Chi tiết hoa hồng</h4>
            <div class="separator separator-dashed my-5"></div>
            <h5>Tìm nhóm sản phẩm:</h5>
            <b-row class="pr-0 my-5">
              <b-col md="6">
                <vue-autosuggest
                  v-model="searchProductFor"
                  :suggestions="filteredOptionsProductFor"
                  @selected="onSelectedProductFor"
                  :limit="10"
                  @input="onInputChangeProductFor"
                  :input-props="{
                    id: 'autosuggest__input',
                    placeholder: 'Nhập tên nhóm sản phẩm',
                    style: 'border-radius:0px!important',
                  }"
                  :should-render-suggestions="
                    (size, loading) => size >= 0 && !loading
                  "
                >
                  <template slot-scope="{ suggestion }">
                    <div>{{ suggestion.item.name }}</div>
                  </template>
                </vue-autosuggest>
              </b-col>
              <b-col md="2"></b-col>
              <b-col md="2"></b-col>
              <b-col md="2" v-if="false">
                <div class="d-flex justify-content-end">
                  <b-button
                    type="button"
                    variant="secondary"
                    size="sm"
                    @click="showModalImportProduct"
                  >
                    <i style="font-size: 1rem" class="far fa-file-excel"></i
                    >Nhập từ excel
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="12">
                <div>
                  <b-table
                    class="table-bordered table-hover col-md-12"
                    :fields="fields"
                    :items="mainModel.rewardProgramDetails"
                    v-if="renderComponent"
                    :busy="isLoading"
                  >
                    <template v-slot:table-busy>
                      <vcl-table
                        :speed="5"
                        :animate="true"
                        :columns="10"
                      ></vcl-table>
                    </template>
                    <template v-slot:cell(count)="row">
                      {{ row.index + 1 }}
                    </template>
                    <template v-slot:cell(amount1)="row">
                      <b-input
                        type="text"
                        size="sm"
                        class="input-style text-right"
                        v-model="row.item.amount1"
                        v-mask="mask"
                      ></b-input>
                    </template>
                    <template v-slot:cell(name)="row">
                      <span
                        style="cursor: pointer"
                        @click="
                          redirectToUpsertRewardProductCategory(
                            row.item.proCateId,
                          )
                        "
                        class="hover-link"
                        >{{ row.item.name }}</span
                      >
                    </template>
                    <template v-slot:cell(amount1Operator)="row">
                      <b-form-select
                        v-model="row.item.amount1Operator"
                        size="sm"
                      >
                        <b-form-select-option value="1" class="text-center">
                          --
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          &lt;
                        </b-form-select-option>
                        <b-form-select-option value="3">
                          &gt;
                        </b-form-select-option>
                        <b-form-select-option value="4">
                          &le;
                        </b-form-select-option>
                        <b-form-select-option value="5">
                          &ge;
                        </b-form-select-option>
                      </b-form-select>
                    </template>
                    <template v-slot:cell(amount2)="row">
                      <b-input
                        type="text"
                        size="sm"
                        class="input-style text-right"
                        v-model="row.item.amount2"
                        v-mask="mask"
                      ></b-input>
                    </template>
                    <template v-slot:cell(amount2Operator)="row">
                      <b-form-select
                        v-model="row.item.amount2Operator"
                        size="sm"
                      >
                        <b-form-select-option value="1">
                          --
                        </b-form-select-option>
                        <b-form-select-option value="2">
                          &lt;
                        </b-form-select-option>
                        <b-form-select-option value="3">
                          &gt;
                        </b-form-select-option>
                        <b-form-select-option value="4">
                          &le;
                        </b-form-select-option>
                        <b-form-select-option value="5">
                          &ge;
                        </b-form-select-option>
                      </b-form-select>
                    </template>
                    <template v-slot:cell(rewardRate)="row">
                      <div
                        class="hover-link"
                        @click="showRewardRateModal(row.item)"
                        style="cursor: pointer; color: blue"
                      >
                        <span v-text="'Mức thưởng'"></span>
                      </div>
                    </template>
                    <template v-slot:cell(proCateTypeShortName)="row">
                      <span
                        v-b-tooltip.hover.top
                        :title="
                          getProCateTypeTooltipTitle(row.item.proCateType)
                        "
                        v-text="row.item.proCateTypeShortName"
                      ></span>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <v-icon
                        small
                        class="text-danger"
                        @click="
                          showDeleteAlert(
                            'Xoá sản phẩm',
                            `Bạn có chắc muốn xoá nhóm sản phẩm ${row.item.name} `,
                            row.index,
                            confirmDeleteItem,
                          )
                        "
                        v-b-tooltip
                        title="Xóa"
                        >mdi-delete</v-icon
                      >
                    </template>
                  </b-table>
                </div>
              </b-col>
              <b-col cols="6" md="4"></b-col>
            </b-row>
          </b-container>
        </b-form>
        <b-modal
          ref="import-product-modal"
          hide-footer
          title="Thêm sản phẩm từ Excel"
          id="modal-prevent-closing"
          size="lg"
        >
          <b-row>
            <b-col>
              <div class="form-group">
                <span>
                  <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                  đúng format, hoặc có thể tải ở
                  <a href="#" @click.prevent="downloadExcelTemplate">đây</a>
                </span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <span> <b>Bước 2:</b> Tiến hành Import </span>
              <div style="padding-top: 15px">
                <b-form-file
                  placeholder="Hãy chọn một tập tin"
                  @change="selectFile"
                  v-model="file"
                  ref="file-input"
                  class="mb-2"
                ></b-form-file>
              </div>
            </b-col>
          </b-row>
          <b-container class="mt-4 pl-0 pr-0" v-show="importItems.length > 0">
            <h5>
              Danh sách sản phẩm từ file excel( Tổng:
              {{ importItems.length }} nhóm sản phẩm)
            </h5>
            <b-table
              id="my-table"
              class="myTable"
              responsive
              bordered
              hover
              :fields="fieldImport"
              :items="importItems"
              :per-page="10"
              :current-page="currentPage"
            >
              <template v-slot:cell(amount1)="row">
                <div style="text-align: end">
                  <span v-text="formatMoney(row.item.amount1)"></span>
                </div>
              </template>
              <template v-slot:cell(amount2)="row">
                <div style="text-align: end">
                  <span v-text="formatMoney(row.item.amount2)"></span>
                </div>
              </template>
              <template v-slot:cell(amount1Operator)="row">
                <span v-if="row.item.amount1Operator === OPERATOR_TYPE.NONE"
                  >--</span
                >
                <span v-if="row.item.amount1Operator === OPERATOR_TYPE.LT"
                  >&lt;</span
                >
                <span v-else-if="row.item.amount1Operator === OPERATOR_TYPE.GT"
                  >&gt;</span
                >
                <span v-if="row.item.amount1Operator === OPERATOR_TYPE.LTE"
                  >&le;</span
                >
                <span v-else-if="row.item.amount1Operator === OPERATOR_TYPE.GTE"
                  >&ge;</span
                >
              </template>
              <template v-slot:cell(amount2Operator)="row">
                <span v-if="row.item.amount2Operator === OPERATOR_TYPE.NONE"
                  >--</span
                >
                <span v-if="row.item.amount2Operator === OPERATOR_TYPE.LT"
                  >&lt;</span
                >
                <span v-else-if="row.item.amount2Operator === OPERATOR_TYPE.GT"
                  >&gt;</span
                >
                <span v-if="row.item.amount2Operator === OPERATOR_TYPE.LTE"
                  >&le;</span
                >
                <span v-else-if="row.item.amount2Operator === OPERATOR_TYPE.GTE"
                  >&ge;</span
                >
              </template>
            </b-table>
            <b-pagination
              v-show="importItems.length > 10"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="10"
              aria-controls="my-table"
            ></b-pagination>
          </b-container>
          <b-button
            style="fontweight: 600; width: 70px"
            variant="primary"
            size="sm"
            @click="validData"
            >Lưu</b-button
          >
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            @click="hideModalImportProduct"
            >Hủy</b-button
          >
        </b-modal>
        <b-modal
          ref="reward-rate-modal"
          hide-footer
          title="Mức thưởng nhân viên"
          id="modal-prevent-closing"
        >
          <b-row>
            <b-col md="3">
              <span style="font-weight: 500">Tên nhóm:</span>
            </b-col>
            <b-col>
              <span>{{ rewardProCateName }}</span>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col md="8">
              <vue-autosuggest
                v-model="searchJobTitle"
                :suggestions="filteredOptionsJobTitle"
                @selected="onSelectedJobTitle"
                :limit="100"
                @input="onInputChangeJobTitle"
                :input-props="{
                  id: 'autosuggest__input',
                  placeholder: 'Nhập tên chức vụ',
                  style: 'border-radius:0px!important',
                }"
              >
                <template slot-scope="{ suggestion }">
                  <div>{{ suggestion.item.name }}</div>
                </template>
              </vue-autosuggest>
            </b-col>

            <b-col md="4" v-if="false">
              <div class="d-flex justify-content-end">
                <b-button
                  variant="secondary"
                  size="sm"
                  @click="visibleSearch = !visibleSearch"
                >
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>Nhập
                  từ excel
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-collapse id="collapse-4" v-model="visibleSearch" class="mb-5">
            <b-row>
              <b-col>
                <div style="padding-top: 15px">
                  <span>
                    <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                    đúng format, hoặc có thể tải ở
                    <a :href="urlExcelER">đây</a>
                  </span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span> <b>Bước 2:</b> Tiến hành Import </span>
                <div>
                  <b-form-file
                    placeholder="Hãy chọn một tập tin"
                    @change="selectFileER"
                    v-model="fileER"
                    ref="file-input"
                    class="mb-2"
                  ></b-form-file>
                </div>
              </b-col>
            </b-row>
          </b-collapse>
          <b-container class="mt-4 pl-0 pr-0">
            <b-table
              class="table-bordered table-hover col-md-12"
              :fields="fieldRewardRate"
              :items="listRewardRate"
              v-if="renderComponent"
            >
              <template v-slot:cell(rewardPoint)="row">
                <b-input
                  type="text"
                  size="sm"
                  class="input-style text-right"
                  v-model="row.item.rewardPoint"
                  v-mask="mask"
                ></b-input>
              </template>
              <template v-slot:cell(actions)="row">
                <v-icon
                  small
                  class="text-danger"
                  @click="showDeleteJobTitleAlert(row.item)"
                  v-b-tooltip
                  title="Xóa"
                  >mdi-delete</v-icon
                >
              </template>
            </b-table>
          </b-container>
          <b-button
            style="fontweight: 600; width: 70px"
            variant="primary"
            size="sm"
            @click="saveemployeeRewardDetails"
            >Lưu</b-button
          >
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            @click="hideRewardRateModal"
            >Hủy</b-button
          >
        </b-modal>
      </template>
      <template v-slot:foot>
        <b-container class="bv-example-row">
          <b-row>
            <b-button v-if="isLoading" variant="primary" disabled>
              <b-spinner small type="grow"></b-spinner>
              Đang lưu...
            </b-button>
            <b-button
              v-else
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              type="submit"
              @click="onSubmit"
              :disabled="isLoading"
              >Lưu</b-button
            >
            <b-button
              style="margin-left: 10px; font-weight: 600; width: 70px"
              variant="secondary"
              size="sm"
              @click="onBack"
              >Hủy</b-button
            >
            <b-col></b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
        <template>
          <ModalImportExcelExcludeBillReward
            ref="modal-exclude-bill-reward"
            @update-exclude-bill-rewards="handleUpdateExcludeBillRewards"
          />
          <ModalExcludeBillRewardList
            ref="exclude-bill-reward-list-modal"
            :list-bill-number="
              mainModel.excludeBillReward?.listBillNumber || []
            "
          />
        </template>
      </template>
    </KTCodePreview>
  </div>
</template>
<style>
.multi-select-wrapper {
  flex: 1 1 auto;
}

.center-label label {
  margin-bottom: 0px;
}

.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: 200px;
  position: absolute;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';
import { getToastInstance } from '../../../utils/toastHelper';
import { reject, isNaN } from 'lodash';
import {
  currencyMask,
  unMaskPrice,
  downloadBlobFile,
  extractFileNameFromHeader,
  handleError,
} from '../../../utils/common';
import {
  formatSpecificDate,
  DATE_FORMAT,
  YEAR_MONTH_DAY_FORMAT,
  checkIsAfterTime,
} from '@/utils/date';
import { showDeleteAlert, showConfirmDialog } from '@/utils/sweet-alert2';

import decounce from 'debounce';
import {
  TIME_TRIGGER,
  URL_IMPORT_EMPLOYEE_REWARD,
  JOB_TITLE,
  REWARD_PROGRAM_TYPE,
} from '@/utils/constants';
import { OPERATOR_TYPE, REWARD_CATEGORY_TYPE } from '@/utils/enum';
import xlsx from 'xlsx';
import VueMultiSelect from 'vue-simple-multi-select';
import { getStartOfDay } from '@/utils/date';
import timeUtils from '@/utils/date';
import { v4 } from 'uuid';
import { VclTable } from 'vue-content-loading';
import ModalImportExcelExcludeBillReward from '@/view/components/rewards/ModalImportExcelExcludeBillReward.vue';
import ModalExcludeBillRewardList from '@/view/components/rewards/ModalExcludeBillRewardList.vue';
import { REWARD_CATEGORY_TYPE_SHORT_NAME } from '@/utils/enum-name';
import apiCommonMixin from '@/view/mixins/api-common.mixins';

export default {
  mixins: [validationMixin, apiCommonMixin],
  data() {
    return {
      REWARD_PROGRAM_TYPE,
      showDeleteAlert,
      OPERATOR_TYPE,
      renderComponent: true,
      dpConfigs: timeUtils.DP_CONFIG,
      mask: currencyMask,
      mainModel: {
        id: 0,
        name: '',
        description: '',
        startAt: getStartOfDay(new Date()),
        endAt: null,
        rewardProgramDetails: [],
        storeIds: [],
        status: true,
        wholesaleStoreIds: [],
        mode: 1,
        departmentId: null,
        excludeBillReward: { listBillNumber: [] },
      },
      fields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'name',
          label: 'Tên nhóm',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'amount1',
          label: 'Giá trị 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'amount1Operator',
          label: 'Toán tử 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'proCateTypeShortName',
          label: 'Loại',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2Operator',
          label: 'Toán tử 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2',
          label: 'Giá trị 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'rewardRate',
          label: '',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
        },
      ],
      filteredOptionsProductFor: [],
      optionsProductFor: [
        {
          data: [],
        },
      ],
      listProduct: [],
      searchProductFor: '',
      stores: '',
      listStatus: [
        {
          id: true,
          name: 'Hoạt động',
        },
        {
          id: false,
          name: 'Không hoạt động',
        },
      ],
      isSearching: false,
      importItems: [],
      file: null,
      fileER: null,
      excellist: [],
      excellistER: [],
      fieldImport: [
        {
          key: 'name',
          label: 'Tên nhóm',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '30%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'amount1',
          label: 'Giá trị 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'amount1Operator',
          label: 'Toán tử 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'dt',
          label: 'DT',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2Operator',
          label: 'Toán tử 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-right',
        },
        {
          key: 'amount2',
          label: 'Giá trị 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-left',
        },
      ],
      currentPage: 1,
      filteredOptionsJobTitle: [],
      optionsJobTitle: [
        {
          data: [],
        },
      ],
      fieldRewardRate: [
        {
          key: 'name',
          label: 'Chức vụ',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '50%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'rewardPoint',
          label: 'Điểm thưởng',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '40%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
        },
      ],
      employeeRewardDetails: [],
      rewardProCateName: '',
      rewardProCateId: null,
      listJobTitle: JOB_TITLE,
      searchJobTitle: '',
      visibleSearch: false,
      urlExcelER: URL_IMPORT_EMPLOYEE_REWARD,
      wholesaleStores: [],
      listDepartment: [],
      listRewardRate: [], // Danh sách riêng để lưu dữ liệu modal
      isLoading: false,
      oldStatus: false,
      originalModel: [],
    };
  },
  validations: {
    mainModel: {
      startAt: {
        required,
        minValue: minValue(0),
      },
      name: {
        required,
      },
    },
  },
  components: {
    KTCodePreview,
    datePicker,
    VueMultiSelect,
    VclTable,
    ModalImportExcelExcludeBillReward,
    ModalExcludeBillRewardList,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Chương trình thưởng hoa hồng',
        route: '/reward/reward-program',
      },
      {
        title: 'Thêm mới chương trình thưởng hoa hồng',
      },
    ]);
  },
  computed: {
    rows() {
      return this.importItems.length;
    },
    excludeBillRewardCount() {
      return this.mainModel.excludeBillReward?.listBillNumber?.length || 0;
    },
  },
  created() {
    if (this.$route.query.mode) {
      this.mainModel.mode = Number(this.$route.query.mode);
    }
    this.fetchJobTitles();
    this.fetchStore();
    this.fetchProductFor();
    this.setDepartmentOptions();
    const id = this.$route.query.id;
    const copyId = this.$route.query.copyId;
    if (id) {
      this.getRewardProgramById(id);
    } else if (copyId) {
      this.getRewardProgramById(copyId, true);
    }
  },
  methods: {
    setDepartmentOptions() {
      this.fetchDepartments().then((departments) => {
        this.listDepartment = departments;
      });
    },
    getProCateTypeTooltipTitle(proCateType) {
      switch (proCateType) {
        case REWARD_CATEGORY_TYPE.REVENUE:
          return 'Tính thưởng theo doanh thu';
        case REWARD_CATEGORY_TYPE.QUANTITY:
          return 'Tính thưởng luỹ tiến theo số lượng';
        default:
          return '';
      }
    },
    redirectToUpsertRewardProductCategory(id) {
      const routeData = this.$router.resolve({
        name: 'update-reward-category',
        query: { id },
      });
      window.open(routeData.href, '_blank');
    },
    showModalImportExcelExcludeBillReward() {
      this.$refs['modal-exclude-bill-reward'].showModal(this.mainModel.id);
    },
    handleUpdateExcludeBillRewards(excludeBillReward) {
      this.mainModel.excludeBillReward = excludeBillReward;
      const count = excludeBillReward?.listBillNumber?.length || 0;
      this.makeToastSuccess(
        `Đã cập nhật ${count} hoá đơn không được tính thưởng`,
      );
    },
    showExcludeBillRewardListModal() {
      if (this.excludeBillRewardCount === 0) {
        this.makeToastFailure('Chưa có hoá đơn nào không được tính thưởng');
        return;
      }
      this.$refs['exclude-bill-reward-list-modal'].showModal();
    },
    ...getToastInstance(),
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    async downloadExcelTemplate() {
      try {
        const rewardTypeMap = {
          [REWARD_PROGRAM_TYPE.HH_CH]: 'template-import-hoa-hong-ch.xlsx',
          [REWARD_PROGRAM_TYPE.HH_CR]: 'template-import-hoa-hong-cr.xlsx',
        };
        const params = {
          rewardType: this.mainModel.mode,
        };
        const response = await ApiService.query(
          'v1/reward-programs//template-import-details',
          {
            params,
            responseType: 'blob',
          },
        );

        const fileName = rewardTypeMap[this.mainModel.mode];
        const fileNameWithTimestamp = extractFileNameFromHeader(
          response.headers['content-disposition'],
          fileName,
        );

        const downloadSuccess = downloadBlobFile(
          response.data,
          fileNameWithTimestamp,
          'template-import-hoa-hong.xlsx',
        );

        if (!downloadSuccess) {
          this.makeToastFailure('Lỗi khi tải template');
          return;
        }

        this.makeToastSuccess('Tải template thành công');
      } catch (error) {
        console.error('Error downloading template:', error);
        this.makeToastFailure('Lỗi khi tải template');
      }
    },
    formatMoney(number) {
      const money = new Intl.NumberFormat('vn-VN').format(number);
      return isNaN(money) ? 0 : money;
    },
    confirmDeleteItem(index) {
      this.mainModel.rewardProgramDetails.splice(index, 1);
    },
    showDeleteJobTitleAlert: function (item) {
      this.listRewardRate = reject(this.listRewardRate, (element) => {
        return element.jobTitleId == item.jobTitleId;
      });
      for (let index = 0; index < this.listJobTitle.length; index++) {
        const element = this.listJobTitle[index];
        if (element.id === item.jobTitleId) {
          this.optionsJobTitle[0].data.push(element);
          this.optionsJobTitle[0].data.sort(this.sortById);
          this.filteredOptionsJobTitle = [
            {
              data: this.optionsJobTitle[0].data,
            },
          ];

          break;
        }
      }
    },
    sortById(a, b) {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    },
    fetchProductFor(textSearch) {
      this.isSearching = true;
      this.listProduct = [];
      this.optionsProductFor[0].data = [];
      ApiService.setHeader();
      ApiService.query(`v1/reward-product-categories/select`, {
        params: {
          name: textSearch,
        },
      }).then(({ data }) => {
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProductFor[0].data.push(element);
        });
        this.filteredOptionsProductFor = [
          {
            data: this.optionsProductFor[0].data,
          },
        ];
        this.isSearching = false;
        if (textSearch !== this.searchProductFor) {
          let nextTextSearch = this.searchProductFor;
          this.fetchProductFor(nextTextSearch);
        }
      });
    },
    onSelectedProductFor(option) {
      this.searchProductFor = '';

      let item = {
        id: v4(), // Tạo ID duy nhất
        rewardProgramCategoryId: option.item.id,
        name: option.item.name,
        amount1: 0,
        amount1Operator: 1,
        dt: 'DT',
        proCateTypeShortName: REWARD_CATEGORY_TYPE_SHORT_NAME[option.item.type],
        amount2: 0,
        amount2Operator: 1,
        employeeRewardDetails: [],
        type: option.item.type,
      };
      this.mainModel.rewardProgramDetails.push(item);
    },
    onInputChangeProductFor(text) {
      this.searchProductFor = text;

      this.debounceInputFor();
    },
    onSelectedJobTitle(option) {
      let item = {
        jobTitleId: option.item.id,
        name: option.item.name,
        rewardPoint: 0,
      };
      this.listRewardRate.unshift(item);
      this.optionsJobTitle[0].data = reject(
        this.optionsJobTitle[0].data,
        (item) => {
          return item.id == option.item.id;
        },
      );
      this.filteredOptionsJobTitle = [
        {
          data: this.optionsJobTitle[0].data,
        },
      ];
      this.searchJobTitle = '';
    },
    onInputChangeJobTitle(text) {
      if (!text) {
        text = '';
      }
      this.searchJobTitle = text;

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionsJobTitle[0].data
        .filter((item) => {
          return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, 10);

      this.filteredOptionsJobTitle = [
        {
          data: filteredData,
        },
      ];
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    onBack: function () {
      this.$router.go(-1);
    },
    checkValidData() {
      if (!this.mainModel.startAt) {
        this.makeToastFailure('Ngày bắt đầu là bắt buộc!');
        return false;
      }
      return true;
    },
    onSubmit: async function () {
      if (!this.checkValidData()) return;
      const rewardProgramDetails = this.mainModel.rewardProgramDetails.map(
        (item) => {
          return {
            ...item,
            amount1Operator: Number(item.amount1Operator),
            amount2Operator: Number(item.amount2Operator),
            amount1: Number(unMaskPrice(item.amount1)),
            amount2: Number(unMaskPrice(item.amount2)),
            employeeRewardDetails: item.employeeRewardDetails.map((ele) => {
              return {
                ...ele,
                rewardPoint: Number(unMaskPrice(ele.rewardPoint)),
              };
            }),
          };
        },
      );
      // Tối ưu xử lý storeIds
      const storeIds =
        this.mainModel.storeIds.length > 0
          ? this.mainModel.storeIds.map((store) => store.id).join(', ')
          : '-1';

      const wholesaleStoreIds =
        this.mainModel.wholesaleStoreIds.length > 0
          ? this.mainModel.wholesaleStoreIds.map((store) => store.id).join(', ')
          : '-1';
      const startDate = formatSpecificDate(
        this.mainModel.startAt,
        DATE_FORMAT,
        YEAR_MONTH_DAY_FORMAT,
      );
      const endDate = formatSpecificDate(
        this.mainModel.endAt,
        DATE_FORMAT,
        YEAR_MONTH_DAY_FORMAT,
      );
      if (startDate && endDate && checkIsAfterTime(startDate, endDate)) {
        this.makeToastFailure('Ngày bắt đầu không được sau ngày kết thúc!');
        return;
      }
      const data = {
        ...this.mainModel,
        startDate,
        endDate,
        rewardProgramDetails,
        storeIds: storeIds,
        wholesaleStoreIds: wholesaleStoreIds,
        rewardType: this.mainModel.mode,
        isActive: Boolean(this.mainModel.status),
      };
      try {
        if (this.mainModel.id && this.oldStatus && this.checkChangeData()) {
          await showConfirmDialog(
            'Cảnh báo!',
            'Bạn có chắc muốn cập nhật chương trình thưởng hoa hồng này không ?\n Sự thay đổi này có thể làm ảnh hưởng đến tổng tiền hoa hồng nhân viên đã thấy trước đó, sẽ gây hiểu lầm cho nhân viên',
          );
        }
        this.isLoading = true;
        const {
          data: { message },
        } = await this.upsertRewardProgramStrategy({
          id: this.mainModel.id,
          data,
        });
        this.makeToastSuccess(message);
        this.onBack();
      } catch (err) {
        handleError(err);
      } finally {
        this.isLoading = false;
      }
    },

    upsertRewardProgramStrategy({ id, data }) {
      if (id) {
        return ApiService.put(`v1/reward-programs/${data.id}`, data);
      } else {
        return ApiService.post('v1/reward-programs/', data);
      }
    },

    checkChangeData() {
      let onlyInBeforeRewardProgramDetail = this.originalModel.filter(
        this.comparerRewardProgramDetail(this.mainModel.rewardProgramDetails),
      );
      let onlyInAfterRewardProgramDetail =
        this.mainModel.rewardProgramDetails.filter(
          this.comparerRewardProgramDetail(this.originalModel),
        );
      if (
        onlyInBeforeRewardProgramDetail.length === 0 &&
        onlyInAfterRewardProgramDetail.length === 0
      ) {
        for (let index = 0; index < this.originalModel.length; index++) {
          const eleOld = this.originalModel[index];
          const eleNew = this.mainModel.rewardProgramDetails[index];
          (eleNew.listEmployeeReward || []).forEach((element) => {
            element.point = element.point * 1;
          });
          let onlyInBeforeER = (eleOld.listEmployeeReward || []).filter(
            this.comparerEmpoyeeReward(eleNew.listEmployeeReward),
          );
          let onlyInAfterER = (eleNew.listEmployeeReward || []).filter(
            this.comparerEmpoyeeReward(eleOld.listEmployeeReward),
          );
          if (onlyInBeforeER.length === 0 && onlyInAfterER.length === 0) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    },
    comparerRewardProgramDetail(otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return (
              other.id == current.id &&
              other.rewardProgramId == current.rewardProgramId &&
              other.rewardProgramCategoryId ==
                current.rewardProgramCategoryId &&
              other.amountOperator1 == current.amountOperator1 &&
              other.amount1 == current.amount1 &&
              other.amountOperator2 == current.amountOperator2 &&
              other.amount2 == current.amount2
            );
          }).length == 0
        );
      };
    },
    comparerEmpoyeeReward(otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return (
              other.id == current.id &&
              other.jobTitleId == current.jobTitleId &&
              other.point == current.point
            );
          }).length == 0
        );
      };
    },
    debounceInputFor: decounce(function () {
      let textSearch = this.searchProductFor;
      if (!this.isSearching) {
        this.fetchProductFor(textSearch);
      }
    }, TIME_TRIGGER),
    convertOperatorType(textOperator) {
      let result = 0;
      switch (textOperator) {
        case '--':
          result = OPERATOR_TYPE.NONE;
          break;
        case '<':
          result = OPERATOR_TYPE.LT;
          break;
        case '>':
          result = OPERATOR_TYPE.GT;
          break;
        case '<=':
          result = OPERATOR_TYPE.LTE;
          break;
        case '>=':
          result = OPERATOR_TYPE.GTE;
          break;
        default:
          result = 0; // Invalid operator
          break;
      }
      return result;
    },
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          const validationErrors = [];

          this.excellist.forEach((element, index) => {
            try {
              const employeeRewardDetails =
                this.createEmployeeRewardFromExcel(element);

              const amount1Operator = this.convertOperatorType(
                element['Toán tử 1'],
              );
              const amount2Operator = this.convertOperatorType(
                element['Toán tử 2'],
              );

              const validOperators = [
                OPERATOR_TYPE.NONE, // 1 - không xác định (--)
                OPERATOR_TYPE.LT, // 2 - nhỏ hơn (<)
                OPERATOR_TYPE.GT, // 3 - lớn hơn (>)
                OPERATOR_TYPE.LTE, // 4 - nhỏ hơn hoặc bằng (<=)
                OPERATOR_TYPE.GTE, // 5 - lớn hơn hoặc bằng (>=)
              ];

              if (!validOperators.includes(amount1Operator)) {
                validationErrors.push(
                  `Dòng ${index + 1}: Toán tử 1 "${element['Toán tử 1']}" không hợp lệ`,
                );
              }

              if (!validOperators.includes(amount2Operator)) {
                validationErrors.push(
                  `Dòng ${index + 1}: Toán tử 2 "${element['Toán tử 2']}" không hợp lệ`,
                );
              }

              if (
                validOperators.includes(amount1Operator) &&
                validOperators.includes(amount2Operator)
              ) {
                let data = {
                  name: element['Tên nhóm'] ? element['Tên nhóm'] : '',
                  amount1: element['Giá trị 1'] ? element['Giá trị 1'] : 0,
                  amount1Operator: amount1Operator,
                  dt: 'DT',
                  amount2: element['Giá trị 2'] ? element['Giá trị 2'] : 0,
                  amount2Operator: amount2Operator,
                  employeeRewardDetails: employeeRewardDetails,
                };
                this.importItems.push(data);
              }
            } catch (error) {
              validationErrors.push(`Dòng ${index + 1}: ${error.message}`);
            }
          });

          if (validationErrors.length > 0) {
            const errorMessage = `Có ${validationErrors.length} lỗi validation:\n${validationErrors.join('\n')}`;
            this.makeToastFailure(errorMessage);
            this.importItems = [];
            return;
          }
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },

    createEmployeeRewardFromExcel(element) {
      const employeeRewardDetails = [];
      const invalidFields = [];

      const rewardFieldMappings = {
        1: [
          {
            excelKey: 'Thưởng Quản lý khu vực',
            jobTitleName: 'Quản lý khu vực',
          },
          {
            excelKey: 'Thưởng Trợ lý cửa hàng',
            jobTitleName: 'Trợ lý cửa hàng',
          },
          {
            excelKey: 'Thưởng Quản lý cửa hàng',
            jobTitleName: 'Quản lý cửa hàng',
          },
          {
            excelKey: 'Thưởng Kế toán bán hàng',
            jobTitleName: 'Kế toán bán hàng',
          },
          {
            excelKey: 'Thưởng Tư vấn bán hàng',
            jobTitleName: 'Tư vấn bán hàng',
          },
          {
            excelKey: 'Thưởng Hỗ trợ kỹ thuật',
            jobTitleName: 'Hỗ trợ kỹ thuật',
          },
          {
            excelKey: 'Thưởng Tiếp đón khách hàng',
            jobTitleName: 'Tiếp đón khách hàng',
          },
        ],
      };

      const currentMode = this.mainModel.mode;
      const fieldMappings = rewardFieldMappings[currentMode] || [];

      const validKeys = fieldMappings.map((field) => field.excelKey);

      /* Validate các cột có title không hợp lệ */
      Object.keys(element).forEach((excelKey) => {
        if (
          excelKey.includes('Thưởng') &&
          element[excelKey] !== undefined &&
          element[excelKey] !== null &&
          element[excelKey] !== ''
        ) {
          if (!validKeys.includes(excelKey)) {
            invalidFields.push(excelKey);
          }
        }
      });

      fieldMappings.forEach((field) => {
        if (
          element[field.excelKey] !== undefined &&
          element[field.excelKey] !== null &&
          element[field.excelKey] !== ''
        ) {
          const rewardPoint = element[field.excelKey] || 0;

          if (rewardPoint === 0) {
            return;
          }

          const jobTitleId = this.getJobTitleIdByName(field.jobTitleName);

          if (jobTitleId === null) {
            invalidFields.push(field.excelKey);
          } else {
            employeeRewardDetails.push({
              jobTitleId: jobTitleId,
              name: field.jobTitleName,
              rewardPoint: rewardPoint,
            });
          }
        }
      });

      if (invalidFields.length > 0) {
        const errorMessage = `Không tìm thấy chức vụ tương ứng cho: ${invalidFields.join(', ')}. Vui lòng kiểm tra lại title Excel mẫu!`;
        throw new Error(errorMessage);
      }

      return employeeRewardDetails;
    },
    getJobTitleIdByName(name) {
      let result = null;
      switch (name) {
        case 'Giám đốc':
          result = 1;
          break;
        case 'Quản lý vùng':
          result = 2;
          break;
        case 'Quản lý khu vực':
          result = 3;
          break;
        case 'Quản lý cửa hàng':
          result = 4;
          break;
        case 'Trợ lý cửa hàng':
          result = 5;
          break;
        case 'Kế toán bán hàng':
          result = 6;
          break;
        case 'Tư vấn bán hàng':
          result = 7;
          break;
        case 'Hỗ trợ kỹ thuật':
          result = 8;
          break;
        case 'Tiếp đón khách hàng':
          result = 9;
          break;
        case 'Kỹ thuật phần cứng':
          result = 10;
          break;
        case 'Giám đốc NHPK':
          result = 11;
          break;
        case 'Nhân viên phụ trách NHPK':
          result = 12;
          break;
        case 'Admin NHPK':
          result = 13;
          break;
        case 'Chuyên doanh phụ kiện':
          result = 14;
          break;
        case 'Trưởng CSKH':
          result = 15;
          break;
        case 'Nhân viên CSKH':
          result = 16;
          break;
        case 'Cộng tác viên CSKH':
          result = 17;
          break;
        case 'Team leader CR LQĐ':
          result = 88;
          break;
        case 'Team leader CR TQK':
          result = 89;
          break;
      }
      return result;
    },
    selectFileER(event) {
      const files = event.target.files[0];
      this.fileER = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.fileER = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellistER = excellist;
          this.excellistER.map((element) => {
            let data = {
              name: element['Chức vụ'] ? element['Chức vụ'] : '',
              jobTitleId: this.getJobTitleIdByName(element['Chức vụ']),
              rewardPoint: element['Điểm thưởng'] ? element['Điểm thưởng'] : 0,
            };
            this.listRewardRate.push(data);
            this.optionsJobTitle[0].data = reject(
              this.optionsJobTitle[0].data,
              (item) => {
                return item.id == data.jobTitleId;
              },
            );
            this.filteredOptionsJobTitle = [
              {
                data: this.optionsJobTitle[0].data,
              },
            ];
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    showModalImportProduct() {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    hideModalImportProduct() {
      this.$refs['import-product-modal'].hide();
    },
    validData() {
      let data = {
        listProduct: this.importItems,
      };
      ApiService.setHeader();
      ApiService.post('v1/reward-programs//valid-import-product', data)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.makeToastSuccess(message);
            response.data.data.forEach((element) => {
              this.mainModel.rewardProgramDetails.push(element);
            });
            this.hideModalImportProduct();
          } else {
            this.makeToastFailure(message);
          }
        })
        .catch((err) => {
          const message = err;
          this.makeToastFailure(message);
        });
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFailure(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    showRewardRateModal(item) {
      this.optionsJobTitle[0].data = [];
      this.listJobTitle.forEach((element) => {
        this.optionsJobTitle[0].data.push(element);
      });
      let tmp = [{ data: this.optionsJobTitle[0].data }];
      this.filteredOptionsJobTitle = tmp;
      this.rewardProCateName = item.name;
      this.rewardProCateId = item.id;

      this.listRewardRate = [];

      if (item.employeeRewardDetails && item.employeeRewardDetails.length > 0) {
        this.listRewardRate = JSON.parse(
          JSON.stringify(item.employeeRewardDetails),
        );
      }
      this.$refs['reward-rate-modal'].show();
    },
    hideRewardRateModal() {
      this.$refs['reward-rate-modal'].hide();
    },
    saveemployeeRewardDetails() {
      const index = this.mainModel.rewardProgramDetails.findIndex(
        (element) => element.id === this.rewardProCateId,
      );

      if (index !== -1) {
        const newEmployeeRewardDetails = JSON.parse(
          JSON.stringify(this.listRewardRate),
        );

        this.$set(
          this.mainModel.rewardProgramDetails[index],
          'employeeRewardDetails',
          newEmployeeRewardDetails,
        );
      }
      this.hideRewardRateModal();
    },
    fetchStore: async function () {
      this.stores = [];
      this.wholesaleStores = [];
      ApiService.get(`stores?limit=1000&page=1`).then((response) => {
        response.data.data.list_store.map((element) => {
          let store = {
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            suggestionName: element.shortName + ' ( ' + element.name + ')',
          };
          this.stores.push(store);
          this.wholesaleStores.push(store);
        });
      });
    },
    getRewardProgramById: async function (rewardProgramId, isCopy = false) {
      this.isLoading = true;
      await ApiService.get('v1/reward-programs/' + rewardProgramId)
        .then((res) => {
          const {
            startDate,
            endDate,
            isActive,
            rewardProgramDetails,
            wholesaleStores,
            stores,
            excludeBillReward,
            rewardType,
            name,
          } = res.data.data;
          Object.assign(this.mainModel, res.data.data);
          // Sao chép: để id = 0 nhằm submit tạo mới (POST); chỉnh sửa thì giữ id để cập nhật (PUT)
          this.mainModel.id = isCopy ? 0 : rewardProgramId;
          this.mainModel.startAt =
            startDate !== null ? moment(startDate).format('DD/MM/YYYY') : '';
          this.mainModel.endAt =
            endDate !== null ? moment(endDate).format('DD/MM/YYYY') : '';
          this.mainModel.status = Boolean(isActive);
          // Đảm bảo mỗi item có ID duy nhất; khi sao chép phải bỏ id gốc của chi tiết và
          // nhân viên (BE không strip id employeeRewardDetails) để tạo bản ghi mới, tránh trùng khóa
          this.mainModel.rewardProgramDetails = rewardProgramDetails.map(
            (item, index) => {
              if (isCopy) {
                item.id = undefined;
                item.employeeRewardDetails = (
                  item.employeeRewardDetails || []
                ).map((ele) => ({ ...ele, id: undefined }));
              }
              if (!item.id) {
                item.id = Date.now() + index + Math.random();
              }
              return item;
            },
          );
          this.mainModel.mode = rewardType;
          this.mainModel.storeIds = stores;
          this.mainModel.wholesaleStoreIds = wholesaleStores;
          this.oldStatus = Boolean(isActive);
          this.originalModel = JSON.parse(JSON.stringify(rewardProgramDetails));
          // BE create cần listBillNumber; excludeBillReward có thể null nên fallback mảng rỗng
          this.mainModel.excludeBillReward = excludeBillReward || {
            listBillNumber: [],
          };
          // Sao chép: đổi tên để tránh lỗi trùng tên khi tạo mới (BE chặn trùng tên)
          if (isCopy) {
            this.mainModel.name = `Bản sao - ${name || ''}`.trim();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async fetchJobTitles() {
      try {
        const {
          data: { data },
        } = await ApiService.get('v1/job-titles');
        this.listJobTitle = data;
      } catch (err) {
        handleError(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.rounded {
  border-radius: 0 !important;
}

.form-group label {
  font-weight: 500;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
.hover-link:hover {
  text-decoration: underline;
}
</style>
